<template>
  <div>
    <template v-if="api_errors.length > 0">
        <div class="mb-2" v-for="error in api_errors" :key="error.message" >
            <vs-alert color="danger" icon="new_releases">
            <small>{{error}}</small>
            </vs-alert>
        </div>
    </template>
    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :disabled="currencyDisabled"
      :list="getList"
      :max-suggestions="10"
      :min-length="1"
      :debounce="200"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27, 35]
      }"
      :mode="mode"
      :nullable-select="true"
      ref="suggestComponent"
      v-bind:placeholder="$t('action.searchAtt', [$t('attribute.currency')])"
      value-attribute="name"
      display-attribute="name"
      @select="onSuggestSelect">

      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div class="misc-item">
          <span>{{$t('action.searchingAtt', [query])}}.</span>
        </div>

        <template v-if="suggestions.length > 0">
          <div class="misc-item">
            <span>{{ suggestions.length }} {{$t('attribute.result')}}</span>
          </div>
          <hr>
        </template>

        <div class="misc-item" v-else-if="!loading">
          <span>{{$t('general.notFound', {msg: $t('attribute.currency')})}}</span>
        </div>
      </template>

      <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.code">
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">
            ( {{scope.suggestion.code}} )
          </div>
          <div class="vx-col sm:w-2/3">
            <p v-html="boldenSuggestion(scope)"></p>
          </div>
        </div>
      </div>

      <div class="misc-item" slot="misc-item-below" v-if="loading">
        <span>{{$t('action.loading')}}...</span>
      </div>
    </vue-simple-suggest>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import ErrorHandler from '@/helper/error_handler'

export default {
  name: 'currency-auto-complete',
  props:['value', 'currencyDisabled'],
  data() {
    return {
      model: this.value,
      mode: 'input',
      loading: false,
      api_errors: []
    }
  },
  components: {
    VueSimpleSuggest
  },
  methods: {
    getList (inputValue) {
      return new Promise((resolve, reject) => {
        let url = this.$endpoints.customer_currencies + '?keyword=' + inputValue
        fetch(url).then(response => {
          if (!response.ok) {
            reject()
          }
          response.json().then(json => {
            const result = []
            const fields = []
            json.data.forEach((part, i) => {
              result.push(part)
            })
            resolve(result)
          }).catch(e => {
            reject(e)
          })
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      })
    },
    onSuggestSelect (suggest) {
      this.$emit('onSelectSuggestion', suggest);
      this.api_errors = []
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
      if(result.length){
        return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)','gi'), '$1<b>$2</b>$3');
      }
    },
  }
}
</script>
